import type { ReactNode, SVGProps } from 'react'

/** Naast "Omhoog" in het rij-acties-paneel (M5.9e), in Lucide-stijl (ontwerp 10.2). Decoratief, altijd naast een knop met zijn eigen `aria-label`. */
export function ArrowUpIcon(props: SVGProps<SVGSVGElement>): ReactNode {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ width: 'var(--nwo-space-sp-4)', height: 'var(--nwo-space-sp-4)', flexShrink: 0 }}
      focusable="false"
      {...props}
    >
      <path d="M12 19V5" />
      <path d="m5 12 7-7 7 7" />
    </svg>
  )
}
